import { render, staticRenderFns } from "./NameSelect.vue?vue&type=template&id=166eb69b&"
import script from "./NameSelect.vue?vue&type=script&lang=js&"
export * from "./NameSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports